import CustodianAccountMatching, { CustodianAccountMatchingDefaultFilters } from "../../features/custodianaccountmatching";
import { FilterProvider } from "../../hooks/FilterContext";
import withProviders from "../../hooks/withProviders";

const CustodianAccountMatchingPage = () => <CustodianAccountMatching />

export default withProviders([FilterProvider, { defaultFilters: CustodianAccountMatchingDefaultFilters, filterStore: 'custodian-accounts' }])(CustodianAccountMatchingPage);
